// FlowVendas Design System v2 — raw design tokens.
// Source of truth: DESIGN-SYSTEM.md §2 (Design tokens).
// Mirrors the CSS custom properties defined in the approved HTML prototypes
// (`design-system.html`, `prototipo-novo-layout-erp.html`).
//
// Keep this file a pure data module (no MUI imports) so it can be reused by
// theme.js, StatusChip and any other place that needs a raw hex value instead
// of a theme.palette.* reference.

export const BRAND = {
    brand1: '#2563eb',
    brand2: '#06b6d4',
    purple: '#8b5cf6',
    gradientBrand: 'linear-gradient(135deg, #2563eb, #06b6d4)',
};

// Screen-scoped gradient (§2.4) — ONLY for the POS / full-screen "operate"
// app bar + totals panel. Never used in the normal app shell.
export const POS_GRADIENT = {
    pos1: { light: '#667eea', dark: '#1e293b' },
    pos2: { light: '#764ba2', dark: '#334155' },
    posTotal: '#fbbf24',
};

export const SEMANTIC = {
    light: {
        success: '#16a34a',
        successBg: '#dcfce7',
        warning: '#f59e0b',
        warningBg: '#fef3c7',
        danger: '#ef4444',
        dangerBg: '#fee2e2',
        info: '#2563eb',
        infoBg: '#dbeafe',
        purpleBg: '#ede9fe',
    },
    dark: {
        success: '#16a34a',
        successBg: '#0f2a1c',
        warning: '#f59e0b',
        warningBg: '#2b2110',
        danger: '#ef4444',
        dangerBg: '#2c1418',
        info: '#2563eb',
        infoBg: '#0f2140',
        purpleBg: '#241a3d',
    },
};

export const NEUTRAL = {
    light: {
        bg: '#f4f6fb',
        surface: '#ffffff',
        surface2: '#f8fafc',
        border: '#e6e9f2',
        text: '#0f172a',
        text2: '#475569',
        text3: '#94a3b8',
    },
    dark: {
        bg: '#0a0e1a',
        surface: '#111827',
        surface2: '#0f1523',
        border: '#232d42',
        text: '#e6e9f5',
        text2: '#a3adc7',
        text3: '#6b7591',
    },
};

// Sidebar always uses its own dark palette — it never flips with light/dark
// mode, it just gets a touch deeper in dark mode (§2.2).
export const SIDEBAR = {
    light: {
        bg: '#0b1224',
        text: '#cbd5e1',
        textDim: '#7d8aa8',
        active: '#152036',
        border: '#1c2740',
    },
    dark: {
        bg: '#080c16',
        text: '#cbd5e1',
        textDim: '#7d8aa8',
        active: '#141d33',
        border: '#1a2338',
    },
};

export const ELEVATION = {
    light: {
        sm: '0 1px 2px rgba(15,23,42,.06)',
        md: '0 6px 20px rgba(15,23,42,.08)',
        lg: '0 20px 50px rgba(15,23,42,.18)',
    },
    dark: {
        sm: '0 1px 2px rgba(15,23,42,.06)',
        md: '0 6px 20px rgba(0,0,0,.35)',
        lg: '0 24px 60px rgba(0,0,0,.55)',
    },
};

export const RADIUS = {
    card: 14,
    control: 10, // buttons, inputs, small chips
    hero: 18, // gradient headers, accordion sections, modals, preview cards
    pill: 20, // fully round pills/badges
};

export const FONT_FAMILY = '"Inter","Roboto","Helvetica","Arial",sans-serif';
